function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-438.63 -92.686)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M451.845,105.722H440.386a1.753,1.753,0,0,1-1.5-2.657l5.729-9.529a1.752,1.752,0,0,1,3,0l5.73,9.529a1.754,1.754,0,0,1-1.5,2.657Zm-5.73-11.636a.349.349,0,0,0-.3.172l-5.729,9.529a.353.353,0,0,0,.3.534h11.459a.344.344,0,0,0,.306-.179.341.341,0,0,0,0-.355l-5.729-9.529A.348.348,0,0,0,446.115,94.086Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446.115,101.62a.9.9,0,1,0,.9.9A.9.9,0,0,0,446.115,101.62Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446.115,96.492a.729.729,0,0,0-.729.73v3.071a.73.73,0,1,0,1.459,0V97.222A.73.73,0,0,0,446.115,96.492Z"
}));

function SvgStatusError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.971,
    height: 13.036,
    viewBox: "0 0 14.971 13.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status_error.8f83bc8b22a1ac95956d74c36c0c33db.svg";
export { ForwardRef as ReactComponent };